import {environment} from 'src/environments/environment';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject, Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {Sorting} from '@brunata-angular/ui';
import {NotificationItem, notificationSchema} from './notification-history/notification.model';
import {mapParseItem, mapParseList} from '@brunata-angular/util';
import {DateTime} from 'luxon';
import {
    EmailLogData,
    emailLogDataSchema,
} from './notification-history/notification-details-modal/email-log-data.model';

@Injectable({
    providedIn: 'root',
})
export class MonitoringService {
    baseUrl = `${environment.onlineServiceUrl}/buildings`;
    sorting = new BehaviorSubject<Sorting>({column: 'notificationSent', direction: 'asc'});

    constructor(private http: HttpClient) {}

    updateSorting(sorting: Sorting): void {
        this.sorting.next(sorting);
    }

    getNotificationHistory(
        buildingNo: string,
        startDate: DateTime,
        endDate: DateTime,
    ): Observable<NotificationItem[]> {
        return this.http
            .get(`${this.baseUrl}/${buildingNo}/notificationhistory`, {
                params: {
                    startdate: startDate.toISO() ?? '',
                    enddate: endDate.toISO() ?? '',
                },
                withCredentials: true,
            })
            .pipe(mapParseList(notificationSchema));
    }

    getEmailLog(emailLogId: number): Observable<EmailLogData> {
        return this.http
            .get(`${environment.onlineServiceUrl}/emaillogs/${emailLogId}`, {
                withCredentials: true,
            })
            .pipe(mapParseItem(emailLogDataSchema));
    }
}
